export default __webpack_public_path__ + "static/typing-b60ff4b385e0ab9dd7f513e574dbf101.jpg";